import keyBy from 'lodash.keyby';
import defaultsDeep from 'lodash.defaultsdeep';
import capitalize from 'utils/string/capitalize';
import {compileVariable} from 'utils/object/objectTemplateCompiler';
import postprocessStatisticsParams from 'store/modules/dashboards/widgets/compileWidget/postprocessStatisticsParams';
import widgetPrototypes from 'store/modules/dashboards/widgets/global/widgetPrototypes';
import _ from 'lodash';
_.noConflict();

const widgetPrototypesMap = keyBy(widgetPrototypes, 'type');

/*
 * add all needed data to widget (dates from datepicker..),
 * postprocess some data (different format on backend and widgets)
 */
export default function compileWidget (widget, dashboardParams, widgetTypesMap) {
  const prototype = widgetPrototypesMap[widget.type];

  // make deep copy to prevent changes in original object during "compilation"
  let compiledWidget = defaultsDeep({}, widget, prototype);

  const dsParamsKey = `ds${capitalize(compiledWidget.dsType)}Params`;
  const argumentsValuesKey = `${widget.type}Values`;

  const defaultArgs = {};
  widgetTypesMap[widget.type].arguments.forEach(item => {
    const defaultVal = item.default;
    if (defaultVal) {
      defaultArgs[item.id] = defaultVal;
    }
  });

  // compile dataSource params (statistics or orders)
  compiledWidget[dsParamsKey] =
    compileVariable(compiledWidget[dsParamsKey], {
      ...defaultArgs, ...compiledWidget[argumentsValuesKey], ...dashboardParams
    });

  if (compiledWidget.dsStatisticsParams) {
    compiledWidget = postprocessStatisticsParams(compiledWidget, 'dsStatisticsParams');
  }

  if (compiledWidget.dsOrdersParams) {
    compiledWidget = postprocessStatisticsParams(compiledWidget, 'dsOrdersParams');
  }

  return compiledWidget;
}
